import type { App } from 'vue'
import { createI18n } from 'vue-i18n'
import { getCurrentLocale, getFallbackLocale } from '@/utils/localeUtils'

export const AppI18n = createI18n({
  legacy: false,

  locale: getCurrentLocale(),

  fallbackLocale: getFallbackLocale(),

  messages: {
    en: {
      noData: 'No Data',
      delete: 'Delete',
      ticket: {
        searchByOrder: 'Search by order number',
        searchByEmail: 'Search by email',
        searchByUsername: 'Search by username',
        noTextSelected: 'Please select text first',
      },
      confirm: 'Confirm',
      cancel: 'Cancel',
      clear: 'Clear',
      reset: 'Reset',
      more: 'More',
      batch: 'Batch',
      total: 'Total: {msg}',
      versionUpdate: {
        title: 'Upgraded version',
        msg: 'A new version has been detected. Do you want to upgrade?',
      },
      form: {
        required: '{msg} field is required.',
        max: 'the maximum value of this field cannot exceed {max}.',
      },
    },

    zh: {
      noData: '暂无数据',
      delete: '删除',
      ticket: {
        searchByOrder: '按工单号搜索',
        searchByEmail: '按邮箱搜索',
        searchByUsername: '按用户名搜索',
        noTextSelected: '请先选中文本',
      },
      confirm: '确定',
      cancel: '取消',
      clear: '重置',
      reset: '重置',
      more: '更多操作',
      batch: '批量操作',
      total: '总计: {msg}',
      versionUpdate: {
        title: '版本更新',
        msg: '检测到新版本，您要升级吗?',
      },
      form: {
        required: '{msg} 字段是必需的。',
        max: '{fieldName} 字段最大值不能超过 {max}。',
      },
    },
  },

  datetimeFormats: {
    'zh-CN': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
      long: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      },
    },
    'en-US': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
      long: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      },
    },
  },
})

export const i18nInstall = (app: App) => {
  app.use(AppI18n)
}
